<template>
  
<div id="vy_body">
  <div id="vy_grid">
    <div id="vy_left_nav" class="p-4">
      <!--左サイドバー-->
      <ShakyoLeftbar v-on:call="call"/>
    </div>
    <div id="vy_main">
      <main>
  <div>
    <h2 class="kojin-title"><slot>{{ title }}</slot></h2>
  </div>
  <div align=center style="padding:0 10px" >
              <hr>
              <!-- パンくずリスト -->
              <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" >
                  <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a href="#" v-on:click="Return_home">Home</a></li>
                      <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
                  </ol>
              </nav>
    
        <input type="button" v-if="type==1" v-on:click="Return_list" value="&nbsp;&nbsp;戻る&nbsp;&nbsp;" class="btn btn-primary" align="center" style="width:200px;height:50px;margin-bottom:10px"/>

        <!--一覧表示-->
        <template v-if="type==0">
          <template v-if="info_list.length == 0">
            お知らせはありません。
          </template>
          <template v-else>
            <div class="vy-search-result-row-head">
            <div class="vy-search-result-column-kojin-head-name" style="width:10%">
              No.
            </div>
           
            <div style="width:50%"  class="vy-search-result-column-kojin-head-age">
              タイトル
            </div>
            <div style="width:20%"  class="vy-search-result-column-kojin-head-exp">
              投稿日
            </div>
            <div style="width:20%" class="vy-search-result-column-kojin-head-pro">
              更新日
            </div>
          </div>

          <div class="vy-search-result">
            <div v-for="(result,i) in info_list" v-bind:key="i" class="vy-search-result-row">
              <div class="vy-search-result-row-a"  v-on:click="Change_detail(result)" style="display: flex;align-items: center;">
                <div style="width:10%;text-align:left" class="vy-search-result-column-kojin-name">{{(i+1)}}</div>
                <div style="width:50%"  class="vy-search-result-column-kojin-exp">{{result.information_title}}</div>
                <div style="width:20%" class="vy-search-result-column-kojin-pro">{{DateTimeSetting(result.toroku_timestamp)}}</div>
                <div style="width:20%" class="vy-search-result-column-kojin-pro" >{{DateTimeSetting(result.update_timestamp)}}</div>
              
              </div>
            </div>
          </div>

        </template>
        </template>

         <!--確認-->
        <template v-else>

            <div style="text-align:left">
            <h4>{{detail_info.information_title}}</h4>
            <div class="vy-dotted"></div>
            <div style="text-align:right;margin:10px 0;">
              <b>投稿日：</b>{{DateTimeSetting(detail_info.toroku_timestamp)}}
            <template v-if="detail_info.toroku_timestamp != detail_info.update_timestamp">
              <b>更新日：</b>{{DateTimeSetting(detail_info.update_timestamp)}}
            </template>
            </div>
            
            <div style="height: 500px;margin-top:10px;overflow-y: scroll;" v-html="detail_info.information_honbun"></div>
            </div>
            <hr>
        </template>

  </div>
        <!--フッター-->
        <FooterArea v-on:call="call"/>
      </main>
    </div>
    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
        <ShakyoRightBar v-on:call="call"/>
    </div>
  </div>
</div>


    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
              v-bind:message_text="message"
              v-bind:message_cat="message_cat"
              v-bind:message_flag="message_flag"
              @close_message="Close_message"
              @ok_message="OK_message"/>
              
</template>

<script setup>
/* eslint-disable */ 
import ShakyoLeftbar from './ShakyoLeftBar.vue'
import ShakyoRightBar from './ShakyoRightBar.vue'
import FooterArea from '../common/FooterArea.vue'
    import MessageModal from './ShakyoMessageModal.vue'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, login_check,DateTimeSetting } from '../js/userdata_shakyo.js'
import AWS from 'aws-sdk';
//import {
//    CognitoUserPool,
//    CognitoUser,
//    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { ref } from 'vue';
import { shallowRef, watch } from 'vue'
import axios from 'axios'
const url = GlobalData.$API_URL
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()

// エラーメッセージ（正常終了時もここに入力）
let results_error = ref("")

let title = "インフォメーション"
GlobalData.shakyo = route.params.shakyo

//---------------- 社協英名から市区町村コードを取得。その後インフォメーションを既読扱いとする
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {
            GlobalData.choson_code = response["data"].choson_code
            information_kidoku()
     }).catch(error => {
          
     })

let information_kidoku = function(){
  axios.post(GlobalData.$API_URL+"Shakyo_Information_update", 
        {choson_code:GlobalData.choson_code,
          information_kidoku:true
        }
        ).then(response => {

          if(response.data.status == 1){
            alert("既読処理に失敗しました。")
          }


     }).catch(error => {
        alert("既読処理に失敗しました。")
          
     })
}

// 今日の日付を取得
let set_date = new Date();
set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
set_date = new Date(set_date);
let nendo = ref(parseInt(set_date.getFullYear()))
let disp_nendo = ref(nendo.value)
login_check();

// 登録済みのインフォメーション
let info_list = ref([]);
let type = ref(0) // 0：一覧、1：確認
let detail_info = ref([]) // 確認中のインフォメーション

// 一覧を取得する
let Info_get = function(){
    type.value = 0 // 表示フラグを「一覧」に切り替え
    axios.post(GlobalData.$API_URL+"Information_get", 
         {del_flg:false}
          ).then(response => {

          info_list.value = response["data"].info 
        }).catch(error => {
            alert("インフォメーションの取得時にエラーが発生しました。"+error)
        })
        
}
  // 選択したインフォメーションを表示する
  let Change_detail = function(info){
    detail_info.value = info
    type.value = 1 // 表示フラグを「確認」に切り替え
  }

  
// 一覧に戻る
let Return_list = function(){ 
    type.value = 0
}

  let Return_home = function(){
      router.push('/'+GlobalData.shakyo+'/Kanri')
  } 

  
  //-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
  const wt = watch(route, () => {
      param = { cmd:route.params.cmd, id:route.params.id }
      call(param)
  })
  
  //-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
  const call = function(proc) {
  
      switch(proc.cmd) {
          case 'open_taikensha':
              // 子コンポーネント側（ShakyoRightBar）からの命令でウィンドウを開く
              
                message_cat.value = 2;
                message_flag.value = true;
                contentMessage.value = MessageModal
              break
          default:
              break
      }
  }

// 初期処理
  Info_get()
</script>
<style scoped>
td {border:none;text-align:right;padding:20px}
</style>
